// extracted by mini-css-extract-plugin
module.exports = {"starGauge":"VMVgr","count":"_2BYMY","average":"mP33E","averageSpan":"_2_HPd","review":"_1JH5W","author":"_1W2Qr","reviewTitle":"_23cec","opinions":"_2Zqtt","separator":"_1cZvf"};